import BaseTemplate from "components/shared/BaseTemplate";
import React from "react";
import { Outlet } from "react-router-dom";

export default function SchoolBase() {
  return (
    <BaseTemplate>
      <Outlet />
    </BaseTemplate>
  );
}
